// @flow

import { completeRequest, beginRequest } from "@store/utils";
import type { AuditLogsState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);
const finishRequest = completeRequest(["requestsInProgress"]);

export const setLoading = (state: AuditLogsState) => () => startRequest(state);
export const setLoaded = (state: AuditLogsState) => () => finishRequest(state);

export const onGetAbsenceAuditLogsListSuccess = (state: AuditLogsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  absenceAuditLogs: payload,
});

export const onGetNotificationAuditLogsSuccess = (state: AuditLogsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  notificationAuditLogs: payload,
});

export const onGetNotificationAuditLogs = (state: AuditLogsState) => ({ payload }: Object) => ({
  ...state,
  ...startRequest(state),
  notificationAuditLogs: [],
});

export const onGetAbsenceAccessAuditLogsListSuccess = (state: AuditLogsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  absenceAccessAuditLogs: payload,
});

export const onGetAuditLogsReset = (state: AuditLogsState) => ({ payload }: Object) => ({
  ...state,
  error: null,
  absenceAuditLogs: [],
  notificationAuditLogs: [],
  absenceAccessAuditLogs: [],
});
